import type { ReactNode } from 'react';
import { Inbox } from 'lucide-react';
import { cn } from '@tsgecart/ui';

export interface AdminEmptyStateProps {
  title: string;
  description?: string;
  icon?: ReactNode;
  action?: ReactNode;
  className?: string;
}

export function AdminEmptyState({ title, description, icon, action, className }: AdminEmptyStateProps) {
  return (
    <div
      className={cn('flex flex-col items-center justify-center gap-2 px-4 py-10 text-center', className)}
    >
      <div className="text-gray-300" aria-hidden="true">
        {icon ?? <Inbox className="h-8 w-8" />}
      </div>
      <p className="text-sm font-medium text-gray-900">{title}</p>
      {description && <p className="max-w-xs text-sm text-gray-500">{description}</p>}
      {action}
    </div>
  );
}
